import React from 'react'
import { FieldRow, Field, InputContainer, FieldValue } from 'plugin-liverig/shared/asset/components/Fieldset'
import { dataToHtml } from 'live/components/forms/ui/RichText'
import { RelativeField, StyledRichText } from 'plugin-liverig/shared/asset/styled'
import i18n from 'live/services/i18n'

export function CsdField({ report, formValues, raw, getFieldProps, inputProps }) {
    return (
        <FieldRow className="Fieldset__FieldRow">
            <Field {...getFieldProps('csd')}>
                <label>{i18n('csd')}</label>
                <InputContainer>
                    <input
                        type="text"
                        {...inputProps('csd')}
                        {...raw({
                            name: 'csd',
                            onChange(e) {
                                return e.target.value
                            }
                        })}
                    />
                </InputContainer>
                <FieldValue className="Fieldset__Value">{report.csd}</FieldValue>
            </Field>
        </FieldRow>
    )
}

export function CSDContacts({ report, formValues, raw, getFieldProps, inputProps }) {
    return (
        <FieldRow className="Fieldset__FieldRow" textarea>
            <RelativeField {...getFieldProps('csdContacts')}>
                <label>{i18n('csdContacts')}</label>
                <InputContainer className="Fieldset__InputContainer">
                    <StyledRichText
                        initialValue={report.csdContacts}
                        {...inputProps('csdContacts')}
                        {...raw({
                            name: 'csdContacts',
                            validateOnBlur: true
                        })}
                    />
                </InputContainer>
                <FieldValue
                    className="Fieldset__Value"
                    textarea
                    dangerouslySetInnerHTML={{ __html: dataToHtml(report.csdContacts) }}
                />
            </RelativeField>
        </FieldRow>
    )
}
